import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const round = (n, d = 2) => {
  if (n === null || n === undefined || isNaN(n) || !isFinite(n)) return null;
  const f = Math.pow(10, d);
  return Math.round(n * f) / f;
};

export const fmt = (n, d = 2) => {
  const r = round(n, d);
  if (r === null) return '—';
  return r.toLocaleString(undefined, { maximumFractionDigits: d });
};
